import { useState, useCallback, useRef } from "react";

export const useContextMenu = () => {
    const anchorRef = useRef<HTMLButtonElement | null>(null);
    const [isOpen, setIsOpen] = useState(false);

    const onOpen = useCallback(() => {
        setIsOpen(true);
    }, []);

    const onClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    return {
        anchorRef,
        isOpen,
        onOpen,
        onClose,
    };
};
